/**
 * Interest topics offered when creating a learner profile (FR-02, max 5).
 *
 * Stored as stable codes (`^[a-z][a-z0-9_]*$`, validated server-side) so
 * labels can change without rewriting learner data.
 */
export const INTEREST_OPTIONS = [
  { code: 'animals', label: 'Động vật', icon: '🐶' },
  { code: 'sports', label: 'Thể thao', icon: '⚽' },
  { code: 'music', label: 'Âm nhạc', icon: '🎵' },
  { code: 'drawing', label: 'Vẽ', icon: '🎨' },
  { code: 'science', label: 'Khoa học', icon: '🔬' },
  { code: 'space', label: 'Vũ trụ', icon: '🚀' },
  { code: 'stories', label: 'Truyện', icon: '📚' },
  { code: 'games', label: 'Trò chơi', icon: '🎮' },
  { code: 'vehicles', label: 'Xe cộ', icon: '🚗' },
  { code: 'cooking', label: 'Nấu ăn', icon: '🍳' },
  { code: 'nature', label: 'Thiên nhiên', icon: '🌳' },
  { code: 'travel', label: 'Du lịch', icon: '✈️' },
] as const

export function interestLabel(code: string): string {
  return INTEREST_OPTIONS.find((o) => o.code === code)?.label ?? code
}
